import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples 
*/
import { NgZorroAntdModule } from 'app/ng-zorro.module';

/* RICH TEXT EDITOR -- DEMO -- CHANGE AS DESIRED (Quill)*/
import { AngularEditorModule } from '@kolkov/angular-editor';


//Should be added for Translations to be loaded on Lazy Loads
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiLingualService } from 'app/BaseFramework/core/services'
import { from } from 'rxjs';
import { SearchProposalComponent } from './search-proposal/search-proposal.component';
import { NewProposalRoutingModule } from './newproposal-routing.module';
import { TransactionProposalDetailsComponent } from './transaction-proposal/transaction-proposal-details.component';
import { SharedComponentsModule } from 'app/ViewModules/shared-components';
import { CustomPipesModule } from 'app/BaseFramework/shared/custom-pipes/custom-pipes.module';
import { ReportsComponent } from './reports/reports.component';
import { AdaptersService, InboxSortService } from 'app/BaseFramework/core/http';


const _components = [SearchProposalComponent, TransactionProposalDetailsComponent, ReportsComponent]
const services = [InboxSortService,AdaptersService]
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularEditorModule,
    NgZorroAntdModule,
    SharedComponentsModule,
    NewProposalRoutingModule,
    CustomPipesModule,
  ],
  declarations: [..._components],
  exports: [..._components],
  providers: [DatePipe,...services]
})
export class NewProposalModule {
  //Should be added for Translations to be loaded on Lazy Loads
  constructor(private translateService: TranslateService,
    private multiLingualService: MultiLingualService) {
    this.multiLingualService.resetLanguageLocales(this.translateService)
  }
}
